import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLandingRouteForUser } from '../shared/_helpers/landingRoute';
import { readCurrentUser } from '../shared/_helpers/currentUser';
import { useAuth } from '../context/AuthContext.jsx';
import Loader from '../components/Loader.jsx';

// SEC-066: the role gate now waits for AuthContext's server-verified role
// rather than trusting the localStorage `currentUser` object, which is
// editable JSON. The server is still the real control either way (SEC-028) —
// this closes the cosmetic gap where an edited role alone used to be enough
// to render the admin UI surface.
const ProtectedRoutes = ({ children, allowedRoles }) => {
  const stored = readCurrentUser();
  const { user, role, status } = useAuth();

  if (!stored?.token) {
    return <Navigate to='/' replace={true} />;
  }
  if (status === 'loading') {
    return <Loader />;
  }
  if (status === 'unauthenticated') {
    return <Navigate to='/' replace={true} />;
  }
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to={getLandingRouteForUser(user)} replace={true} />;
  }
  return children;
};
export default ProtectedRoutes;
